import { render } from "./ProfileCreate.vue?vue&type=template&id=6004bf88"
import script from "./ProfileCreate.vue?vue&type=script&lang=js"
export * from "./ProfileCreate.vue?vue&type=script&lang=js"

import "./ProfileCreate.vue?vue&type=style&index=0&id=6004bf88&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__